var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-timeline-node',_vm._b({class:{'private-note': _vm.data.is_private}},'y-timeline-node',_vm.nodeBind,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }